import { render, staticRenderFns } from "./PopupButtonClose.vue?vue&type=template&id=e581434c&scoped=true"
import script from "./PopupButtonClose.vue?vue&type=script&lang=js"
export * from "./PopupButtonClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e581434c",
  null
  
)

export default component.exports